/**
 * Original material-ui Collapse sets "overflow: hidden" in both visible
 * and collapsed states. This doesn't work with react-select dropdown menu
 * which gets clipped by Collapse component
 *
 * This component overrides overflow setting in expanded ("entered") state
 */
import React from "react";
import MuiCollapse, { CollapseProps } from "@material-ui/core/Collapse";

export class Collapse extends React.Component<CollapseProps> {
  ref: any;

  setRef = (ref) => {
    if (ref) {
      this.ref = ref;
    }
  };

  componentDidMount() {
    if (this.ref && this.props.in) {
      if (this.ref.wrapperRef) {
        this.ref.wrapperRef.parentNode.style.overflow = "visible";
      }
    }
  }

  render() {
    return (
      <MuiCollapse
        {...this.props}
        innerRef={this.setRef}
        onEntered={(node) => setTimeout(() => (node.style.overflow = "visible"), 250)}
        onExiting={(node) => (node.style.overflow = "hidden")}
      />
    );
  }
}
export default Collapse;
